import { QueriesResults, useQueries, useQuery, UseQueryResult } from "react-query";
import { UploadResponse } from "../hooks/useUpload";

const getFilesFromBucketLink = async (
  files: UploadResponse[]
): Promise<File[]> => {
    return await Promise.all(
      files.map(async (file) => {
        if (file.public_bucket_link) {
          const response = await fetch(file.public_bucket_link);
          const responseBlob = await response.blob();
          return new File([responseBlob], file.filename, {
            type: response.headers.get('Content-Type') || '',
          });
        }

        return Promise.reject();
      }),
    );

};

export const getFilesFromDocumentAPIQKey = (files?: UploadResponse[]) => [
  files,
];

/**
 * Use 'useDocumentFiles' instead 
 * @depracated
 */
const useFilesFromDocumentAPI = (files: UploadResponse[]): UseQueryResult<File[]> => {
return useQuery(
  getFilesFromDocumentAPIQKey(files),
  async () => await getFilesFromBucketLink(files),
  { enabled: !!files.length, refetchOnWindowFocus: false },
);
}

const getFileFromBucketLink = async (document: UploadResponse): Promise<File> => {
  if (document.public_bucket_link) {
    const response = await fetch(document.public_bucket_link);
    const responseBlob = await response.blob();
    return new File([responseBlob], document.filename, {
      type: response.headers.get('Content-Type') || '',
    });
  }
  return Promise.reject();
}

export const useDocumentFiles = (documents: UploadResponse[]): QueriesResults<File[]> => {
  return useQueries<File[]>(
    documents.map((document) => ({
      queryKey: Object.values(document),
      queryFn: () => getFileFromBucketLink(document),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    })),
  );
};

export default useFilesFromDocumentAPI;